import Transformer from './../transformer'

export default class MaterialsQuotationTransformer extends Transformer {
  static fetch(consolidated) {
    return {
      // Data
      id: consolidated.id,
      quantity: consolidated.quantity,
      supplyPrice: consolidated.unit_price,
      highwayId: consolidated.highway.id,
      highway: consolidated.highway.highway,
      receiveId: consolidated.receive.id,
      receive: consolidated.receive.name,
      // Supply -> Object
      supplyCode: consolidated.code_supply,
      supplyName: consolidated.supply.supply_name,
      supplyFamilyId: consolidated.supply.supply_family_id,
      supplyFamily: consolidated.supply.supply_family_name,
      supplySubFamilyId: consolidated.supply.supply_sub_family_id,
      supplySubFamily: consolidated.supply.supply_sub_family_name,
      supplyUnitMeasurement: consolidated.supply.supply_unit_measurement,
      // Requisitions -> List of Objects
      requisitions: consolidated.requisitions,
      // Providers -> List of IDs
      providers: consolidated.providers,
      sinRequisitionNumber: consolidated.requisition_number
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/consolidatedSupplies.js